module.exports = __webpack_public_path__ + "7fd3bf81746160268156810602606860.svg";